import React, { useState } from 'react';
import { Send } from 'lucide-react';
export const ContactPanel = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    postcode: '',
    appliance: '',
    faultNotes: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Form submission logic would go here
    console.log('Form submitted:', formData);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <div className="bg-white rounded-xl shadow-lg p-8 md:p-12" data-id="element-21">
      <h2 className="text-3xl font-bold text-slate-800 mb-6" data-id="element-22">
        Request a Repair
      </h2>
      <p className="text-slate-600 mb-8" data-id="element-23">
        Fill in the form below and we'll get back to you within 24 hours to
        arrange your repair visit.
      </p>
      <form onSubmit={handleSubmit} className="space-y-6" data-id="element-24">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-25">
          <div data-id="element-26">
            <label htmlFor="name" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-27">
              Full Name *
            </label>
            <input type="text" id="name" name="name" required value={formData.name} onChange={handleChange} className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-28" />
          </div>
          <div data-id="element-29">
            <label htmlFor="email" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-30">
              Email Address *
            </label>
            <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-31" />
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-32">
          <div data-id="element-33">
            <label htmlFor="phone" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-34">
              Phone Number *
            </label>
            <input type="tel" id="phone" name="phone" required value={formData.phone} onChange={handleChange} className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-35" />
          </div>
          <div data-id="element-36">
            <label htmlFor="postcode" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-37">
              Postcode *
            </label>
            <input type="text" id="postcode" name="postcode" required value={formData.postcode} onChange={handleChange} className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-38" />
          </div>
        </div>
        <div data-id="element-39">
          <label htmlFor="appliance" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-40">
            Appliance Type *
          </label>
          <select id="appliance" name="appliance" required value={formData.appliance} onChange={handleChange} className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-41">
            <option value="" data-id="element-42">Select an appliance</option>
            <option value="washing-machine" data-id="element-43">Washing Machine</option>
            <option value="dishwasher" data-id="element-44">Dishwasher</option>
            <option value="tumble-dryer" data-id="element-45">Tumble Dryer</option>
            <option value="cooker" data-id="element-46">Cooker/Oven</option>
            <option value="fridge-freezer" data-id="element-47">Fridge/Freezer</option>
            <option value="tv" data-id="element-48">TV/Set-Top Box</option>
          </select>
        </div>
        <div data-id="element-49">
          <label htmlFor="faultNotes" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-50">
            Fault Description *
          </label>
          <textarea id="faultNotes" name="faultNotes" required rows={4} value={formData.faultNotes} onChange={handleChange} placeholder="Please describe the problem with your appliance..." className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-51" />
        </div>
        <button type="submit" className="w-full bg-blue-500 text-white px-8 py-4 rounded-lg hover:bg-blue-600 transition-colors font-semibold text-lg flex items-center justify-center space-x-2" data-id="element-52">
          <span data-id="element-53">Submit Request</span>
          <Send className="w-5 h-5" data-id="element-54" />
        </button>
      </form>
    </div>;
};